export default __webpack_public_path__ + "static/media/cage-circle-grey.a7bccade.svg";